interface CountryDomains {
    [key: string]: string;
}

const countryDomains: CountryDomains = {
    ca: 'canada',
    com: 'us',
};

interface CountryCodes {
    [key: string]: 'us' | 'ca';
}

const countryCodes: CountryCodes = {
    us: 'us',
    canada: 'ca',
};

export const getCountryCodeForCountry = (
    country: string,
): 'us' | 'ca' | null => {
    if (country.toLowerCase() in countryCodes) {
        return countryCodes[country.toLowerCase()];
    }
    return null;
};

export const getCountryFromUrl = (str: string | null) => {
    if (str === null) {
        return null;
    }

    // TODO: Remove this once we have a solution for SIT envs
    // Does the url path contain /CAN-SIT
    const strWithoutQueryParams = str.split('?')[0];
    if (strWithoutQueryParams.includes('/CAN-SIT')) {
        return 'canada';
    }

    const strWithoutProtocolAndPort = str
        .replace(/^https?:\/\//gi, '')
        .split(':')[0];
    const pieces = strWithoutProtocolAndPort.split('.');
    // Is the subdomain can
    if ([pieces[0], pieces[1]].includes('can')) {
        return 'canada';
    }
    // Does the subdomain start with can-
    if (pieces[0].startsWith('can-') || pieces[1].startsWith('can-')) {
        return 'canada';
    }
    // Does the subdomain equal uatca (being served from our UAT env)
    if (pieces[0].toLowerCase() === 'uatca') {
        return 'canada';
    }

    // Is the top level domain .ca
    const host = strWithoutProtocolAndPort.split('/')[0].split('?')[0];
    const domain = host.split('.').pop();
    if (!domain) {
        return null;
    }
    return countryDomains[domain] || null;
};

interface Language {
    supported: ('en-CA' | 'en-US' | 'fr-CA')[];
    default: 'en-CA' | 'en-US' | 'fr-CA';
}
const languagesByCountryCode: { us: Language; ca: Language } = {
    us: { supported: ['en-US'], default: 'en-US' },
    ca: { supported: ['en-CA', 'fr-CA'], default: 'en-CA' },
};

export const getLocaleConfigForCountryCode = (countryCode: 'us' | 'ca') => {
    return {
        languages: {
            ...languagesByCountryCode[countryCode],
        },
    };
};
